<template>
    <div>
        <b-badge
            :variant="$store.getters['shipping/status2variant'](model.status)"
            >{{
            trans.labels[
            'shippings.status.' + model.status
            ]
            }}</b-badge>
<!--
        <font-awesome-icon icon="link" class="fa-fw" v-if="!model.is_public" />
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>

